import { render, staticRenderFns } from "./ApplyMaterials.vue?vue&type=template&id=31676347&"
import script from "./ApplyMaterials.vue?vue&type=script&lang=js&"
export * from "./ApplyMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports